var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import Component from 'vue-class-component';
import { namespace } from 'vuex-class';
import { UiButton, UiModal } from '@claims-ia/design-system';
import RoomDamageQuoteForm from '@declaration/components/receipt/RoomDamageQuoteForm.vue';
const roomDamageQuote = namespace('roomDamageQuote');
let RoomDamageQuoteModal = class RoomDamageQuoteModal extends Vue {
    constructor() {
        super(...arguments);
        this.isSaving = false;
    }
    get change() {
        return this.changeGetter(this.changeKey);
    }
    get validation() {
        return this.validationGetter(this.changeKey);
    }
    get receipt() {
        return this.change.data;
    }
    get invalidForm() {
        return !this.validation.isValid;
    }
    async saveReceipt() {
        this.isSaving = true;
        try {
            await this.saveChanges();
            this.onClose();
        }
        catch (_a) { }
        this.isSaving = false;
    }
    onClose() {
        this.$emit('close');
    }
};
__decorate([
    roomDamageQuote.Getter('change')
], RoomDamageQuoteModal.prototype, "changeGetter", void 0);
__decorate([
    roomDamageQuote.Getter('validation')
], RoomDamageQuoteModal.prototype, "validationGetter", void 0);
__decorate([
    roomDamageQuote.Action('saveChanges')
], RoomDamageQuoteModal.prototype, "saveChanges", void 0);
__decorate([
    roomDamageQuote.Action('validateAndRevealDamages')
], RoomDamageQuoteModal.prototype, "validateReceipt", void 0);
__decorate([
    roomDamageQuote.Action('deleteDamage')
], RoomDamageQuoteModal.prototype, "deleteReceipt", void 0);
RoomDamageQuoteModal = __decorate([
    Component({
        components: {
            RoomDamageQuoteForm,
            UiModal,
            UiButton,
        },
        props: {
            isDisplayed: { type: Boolean, required: true },
            changeKey: { type: [Number, String], default: null },
        },
    })
], RoomDamageQuoteModal);
export default RoomDamageQuoteModal;
